/* eslint-disable @typescript-eslint/ban-ts-comment */
import { addModal } from 'weblite-web-modal-viewer'
import { ForceUpdateWebDialog } from './force-update-web-dialog'

const COMPONENT_ID = 'forceUpdateWeb'

export const showWebForceUpdateModal = (callBack: () => Promise<unknown>) =>
  addModal({ id: COMPONENT_ID, props: { cb: callBack } })

export default {
  [COMPONENT_ID]: {
    Component: ForceUpdateWebDialog,
  },
}
